import React from 'react';
import { Block } from './block';

export function HeaderBlock({ children, className }) {
    return <Block noEdit className={className}>{children}</Block>
}